<div class="container">
  <div class="row">
    <div class="col-md-2">
      <label for="filterPeriod" class="form-label form-label-sm ">Periodo</label>
      <select id="filterPeriod" class="form-select form-select-sm" [(ngModel)]="selectedPeriod">
        <option value="">Seleccione un periodo</option>
        <option *ngFor="let p of periods" [value]="p._id">{{p.name}}</option>
      </select>
    </div>

    <div class="col-md-2">
      <label for="" class="form-label form-label-sm">Estado (Pendiente)</label>
      <select id="" class="form-select form-select-sm" [(ngModel)]="stateId">
        <option value="">Seleccione Estado</option>
        <option *ngFor="let r of reportstates" [value]="r._id">{{r.name}}</option>
      </select>
    </div>

    <!-- Bóton Buscar  -->

    <div class="col-md-2  mt-2">
      <button class="btn btn-secondary btn-sm w-100" (click)="onSearch()">Buscar</button>
    </div>

    <div class="col-md-2 mt-2">
      <button class="btn btn-sm btn-success w-100" (click)="downnloadExcel()"><i class="fas fa-file"></i>
        Excel Previo</button>
    </div>
    <!--  <div class="col-md-2 mt-2">
      <button class="btn btn-sm btn-secondary" (click)="downloadPDF()"><i class="fas fa-file"></i>
        PDF Previo </button>
    </div> -->
    <div class="col-md-2 mt-2">
      <button class="btn btn-sm btn-primary w-100" data-bs-toggle="modal" data-bs-target="#uploadPaymentsModal"><i
          class="fas fa-file"></i>
        Generar Pago</button>
    </div>
  </div>

  <div class="row" *ngIf="reports.length > 0">
    <!-- Tabla -->

    <div class="table-responsive p-3">
        <table class="table table-hover table-sm align-middle border border-secondary rounded-4 mt-4">
          <thead class="table-primary text-center">
            <tr>
              <th>Código</th>
              <th>Nombre</th>
              <th>Rut</th>
              <th>Valor Informe</th>
              <th>Periodo</th>
              <th>Fecha de Envio</th>
              <th>Estado</th>
              <th>Retraso</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let r of reports" class="text-center form-label-sm"
              [ngClass]="{ 'bg-warning': r.isLate === false }">
              <td>{{ r.user.employee_code }}</td>
              <td>{{ r.user.name }}</td>
              <td>{{ r.user.rut}}</td>
              <td>${{ r.value | number: '1.0-0':'es-ES'}}</td>
              <td>{{r.period.name}}</td>
              <td> {{ r.createdAt | date: 'dd-MM-yyyy'}}</td>
              <td>
                <span class="badge" *ngIf="r.state?.name" [ngClass]="{
            'bg-success': r.state.name === 'Aprobado',
            'bg-info text-dark': r.state.name === 'En revisión',
            'bg-danger': r.state.name === 'Rechazado',
            'bg-warning text-dark':r.state.name === 'En Corrección',
            'bg-primary': ['Aprobado', 'En revisión', 'Rechazado', 'En Corrección'].indexOf(r.state.name) === -1}">
                  {{ r.state.name }}
                </span>
              </td>
              <td>
                <span class="badge" [ngClass]="{
                    'bg-danger': r.isLate === true,
                    'bg-success': r.isLate === false
                  }">
                  {{ r.isLate ? 'Atrasado' : 'En Plazo' }}
                </span>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
  </div>

  <p *ngIf="reports.length === 0" class="text-center">No se encontraron informes para el periodo seleccionado.</p>
</div>


<!-- Modal para Guardar Pagos -->
<div class="modal fade" id="uploadPaymentsModal" tabindex="-1" aria-labelledby="uploadPaymentsLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="uploadPaymentsLabel">Archivos Respaldo</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Cerrar"></button>
      </div>
      <div class="modal-body">

        <!--titulo obligatorio-->
        <div class="mb-3">
          <label for="title" class="form-label">Título</label>
          <input type="text" class="form-control" id="title" [(ngModel)]="paymentTitle" required>
        </div>

        <!--comentario del que sube-->
        <div class="mb-3">
          <label for="comment" class="form-label">Comentario</label>
          <textarea class="form-control" id="comment" rows="3" [(ngModel)]="paymentComment"></textarea>
        </div>

        <!--varios archivos-->
        <div class="mb-3">
          <label for="formFile" class="form-label">Seleccione comprobantes de pago</label>
          <input class="form-control" type="file" id="formFile" (change)="onFileSelected($event)" multiple>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
          <button type="button" class="btn btn-primary" (click)="savePayment()">Subir Pagos</button>
        </div>
      </div>
    </div>
  </div>